import React, { Component } from 'react';
import { navigate } from '../modules/high_level_actions';
import { connect } from 'react-redux';

class TermsOfMembershipNegOp extends Component {
  render() {
    let singleProduct = "book",
        pluralProduct = "books",
        featuredSelections = "Featured Selections",
        percentage = "25%",
        publisherPrices = "Publishers’ Edition prices",
        reading ="reading",
        company = "Bookspan, LLC";
    if(this.props.store.tla==="DVD"){
      singleProduct = "DVD", pluralProduct= "DVDs", featuredSelections = "Director's Selection", percentage = "60%",
      publisherPrices = "regular Club prices", reading="watching", company = "Edge Line Ventures, LLC";
    }
    return (
      <div className="content-max-width cms">
        <div className="content-max-width">
          <a href="/" className="button btn-secondary float-right" onClick={(evt) => this.props.dispatch(navigate(evt))}>&times;</a>
          <h2>{this.props.store.name} Member Terms</h2>
        </div>
        <div className="modal-body">
          <p>
            Welcome to The {this.props.store.name}! This Website located at {this.props.store.url} (the "Site")
            is owned and operated by {company} (the "Company"). This Site and any purchases made
            through this Site are governed by the membership terms described below, as well as the
            terms of use and privacy policy found in the footer of the home page (“Terms”). You must
            be at least 18 years old to purchase products from this Site or use the {this.props.store.name}
            services. By using this Site, purchasing items through this Site, and/or enrolling in our
            {" " + this.props.store.name} Membership Program (which includes a monthly, automatic purchase feature as
            described below), you agree to be bound by these terms, so please review this entire
            page carefully.
          </p>

          <h6>HASSLE-FREE MEMBERSHIP </h6>
          <p>
            {this.props.store.name}  has a simple one-{singleProduct} purchase commitment, no further commitments to purchase any {pluralProduct},
            and you can cancel your membership at any time.
          </p>

          <h6>JOINING THE {this.props.store.name.toUpperCase()} MEMBERSHIP PROGRAM</h6>
          <p>
            To become a {this.props.store.name.toUpperCase()} Member, add any two {pluralProduct} on this Site to your cart for just ${this.props.store.second_book} each and proceed to
            checkout. When you complete your purchase you can enroll in the {this.props.store.name.toUpperCase()} Membership Program by checking the
            appropriate box confirming your agreement to these membership terms.
          </p>

          <h6>HOW THE {this.props.store.name.toUpperCase()} MEMBERSHIP PROGRAM WORKS</h6>
          <p>
            As a {this.props.store.name} Member, you will receive an email every few weeks announcing our latest {featuredSelections},
            highlighting the best new {pluralProduct}. You’re free to take any {featuredSelections}—or skip it altogether and save on only
            the {pluralProduct} you want.
          </p>
          <ul className="list">
            <li>Enjoy savings of up to {percentage} off {publisherPrices}—no other purchase necessary.</li>
            <li>Get free shipping with every order of three or more {pluralProduct}.</li>
            <li>There is no obligation to buy and you may cancel your membership at any time with no further obligation on the account page on this site or by contacting
            Member Services at {this.props.store.member_services_phone}.</li>
          </ul>
          <p>
            You must keep a valid credit/debit card on file in order to be a {this.props.store.name} Member. If you do not provide a valid
            credit/debit card for two (2) or more consecutive months, we may cancel your membership.
          </p>

          <h6>{this.props.store.name.toUpperCase()} MEMBERSHIP – MEMBER PRICING & PROMOTIONS</h6>
          <p>
            As a {this.props.store.name} Member, you will be able to purchase {this.props.store.name.toUpperCase()} titles at discounted Member’s-only prices.
            {this.props.store.name} {pluralProduct} may differ in certain respects from publisher’s editions. From time to time, {this.props.store.name + " "}
            provides its members with special promotional offers. All promotional offers are subject to specific rules and regulations,
            which will be clearly explained via a link on the site. From time to time, you will also receive emails advising you about your
            account and promotions, newsletters, special offers and other updates to maximize your {reading} experience. You can decide which
            promotional emails you want to receive by visiting the Account Section of this website. We may share your information with other
            clubs or websites operated by our parent or affiliated companies. From time to time, {this.props.store.name} may arrange for other
            companies to provide you with offers for products or services.
          </p>

          <h6>SHIPPING</h6>
          <p>
            Standard Shipping is free for all orders of three or more {pluralProduct} (the subtotal in your cart must be at least $35);
            certain exclusions may apply from time to time. Standard shipping and processing on a purchase of 1 {singleProduct} is $5.99. You can find
            your order details and tracking information (when available) in the Account Section of this website. If shipment of your order is
            delayed, we will notify you via email.
          </p>

          <h6>RETURNS</h6>
          <p>
            If for any reason you are not happy with your purchase, you can return it for a refund, subject to the following terms and
            limitations. We only accept returns received within 30 days from the original date of shipment. The payment method used
            for the purchase will be credited. Shipping and processing fees, if applicable, will not be refunded. Any returned item must be
            in new, unused and resalable condition, and should be sent back in the original packaging. To make a return, please follow these steps:
          </p>
          <ol>
            <li>Call our toll free number at {this.props.store.member_services_phone}. Our Member Services team will email you our pre-paid return shipping label.</li>
            <li>Return the item in its original packaging.</li>
            <li>Attach the pre-paid return shipping label to your shipment and drop it off at any USPS location.</li>
          </ol>

          <h6>SALES TAX</h6>
          <p>
              {this.props.store.name} is required to collect sales tax when applicable.
          </p>

          <h6>PAYMENT OPTIONS</h6>
          <p>
            The credit/debit card you provide will be used for all future purchases and charges, including purchases of Member Credits.
            You must keep a valid credit/debit card on file during the term of your membership and you must keep us up-to-date with
            accurate member information, including your name, address, credit or debit card number and expiration date. You agree that
            we may update your information with information your bank or credit card issuer may supply.
          </p>
          <p>
            Once you become a member, if you wish to change your credit/debit card, just visit the “Account” section of our website.
            You can also change or edit your payment method when placing an order or making a payment with your credit/debit card. We
            will continue to apply your payments under this payment method unless you change your payment preference in the account section
            of the website, or notify us through Member Services to change your billing preference. We accept payment by credit/debit card
            (i.e., American Express, VISA, Discover and MasterCard).
          </p>
          <p>
            If you have selected a credit or debit card as your payment method and the charge cannot be processed on that card (for example,
            the card has expired or we cannot obtain authorization from your card issuer), then for your convenience, we will attempt to
            charge any other credit or debit card that you have placed on file with us, in order to prevent disruption of your membership. We
            are not responsible for any fees or charges that your bank, credit card or debit card issuer may apply. If your credit card issuer
            reverses a charge to your credit card, we may bill your account directly and seek payment by another method through a mailed
            statement. We may report information about your account to credit bureaus.
          </p>

          <h6>FOR PERSONAL USE ONLY</h6>
          <p>
            All products purchased through {this.props.store.name} are intended for personal use only and not for resale or any other commercial purpose.
            We reserve the right to cancel the account of any member suspected of violating this requirement and may limit the number of
            copies/titles that may be ordered on any account.
          </p>

          <h6>NOTICE OF ARBITRATION AGREEMENT</h6>
          <p>
            {company} and you agree to arbitrate all disputes and claims between us arising out of or relating to this Agreement, as broadly
            interpreted to include any aspect of our relationship, including claims related to advertising. You thus give up your right to go to
            court, except that you may bring an action against us in small claims court. The arbitration will be under the prevailing Commercial
            Arbitration Rules and the Supplementary Procedures for Consumer Related Disputes of the American Arbitration Association
            (the “AAA Rules”), as modified by this Agreement. The AAA Rules, including how to initiate a claim, are available online at
            www.adr.org or by calling the AAA at 800-778-7879. If you choose arbitration, your rights will be determined by a neutral arbitrator
            and not by a judge or jury. You are entitled to a fair hearing, but arbitration procedures are simpler and more limited than rules
            applicable in court. Arbitrator decisions are as enforceable as any court order and are subject to very limited review by a court.
          </p>
          <p>
            Arbitrations will be conducted by one Arbitrator and will be Desk Arbitrations unless you or we request a Telephonic Hearing (as
            defined by AAA Rules). There will be no In-Person Hearing unless a claim seeks more than $75,000. We will pay all filing,
            Administration, and arbitrator fees, unless the Arbitrator finds that your claim had no reasonable foundation or was brought for an
            improper purpose, in which case the Arbitrator must order you to pay those costs. After you notify us that you have commenced
            arbitration, we will promptly reimburse you the filing fee. If the Arbitrator issues an award in your favor on the merits of your
            claim that is greater than the value of our last written settlement offer made before the Arbitrator was selected, then the
            arbitrator also may award you your reasonable attorney’s fees. We will not seek attorney’s fees from you even if we prevail. The
            arbitrator will be bound by this Agreement.
          </p>
          <p>
            The Arbitrator may award declaratory or injunctive relief only in favor of the party seeking relief and only as necessary to provide
            relief warranted by that party's individual claim. You and {company} agree that each may bring claims against the other only in
            your or our individual capacity, and not as a plaintiff or class member in any purported class or representative proceeding.
            Further, unless both you and {company} agree otherwise, the Arbitrator may not consolidate more than one person's claims, and
            may not otherwise preside over any form of a representative or class proceeding. If this specific provision is found to be
            unenforceable, then the entirety of this arbitration provision shall be null and void.
          </p>

          <h6>CHANGES TO MEMBERSHIP</h6>
          <p>
            We're always looking at ways to improve your membership experience. Accordingly, please note that {this.props.store.name} services, promotions,
            policies, benefits, charges, programs, and Terms are subject to change at any time. Please check here periodically for updates. We
            will always notify you in advance of any changes, either via email or via our Site. By enrolling and continuing to use or purchase
            products from this Site and/or continuing your membership, you accept and agree to the Terms and any changes so long as they are
            promptly posted on the Site or emailed to the email account we have on record for you. If you do not wish to be bound to
            these Terms (or any revisions to these Terms), please do not use this Site or the Company's services and immediately cancel your
            {" " + this.props.store.name} Membership without further obligation by calling one of our member services representatives at {this.props.store.member_services_phone}
          </p>
          <p>
            We reserve the right to request additional information, reject any application, or cancel any membership.
          </p>
        </div>
      </div>
    );
  }
};


function mapStateToProps(state){
    return { 'store': state.store };
}

export default connect(mapStateToProps)(TermsOfMembershipNegOp);


// WEBPACK FOOTER //
// ./src/components/TermsOfMembershipNegOp.jsx